import i18next from 'i18next';

import { duplicateProduct } from 'common/api/productsBulk';
import showToast from 'common/utils/showToast';

import {
    DUPLICATE,
    DUPLICATE_SUCCESS,
    DUPLICATE_FAILURE,
} from '../actionTypes';
import { actions } from '../reducer';

import fetchItems from './fetchItems';

export default (filterData, id) => (dispatch) => {
    dispatch(actions[DUPLICATE]());
    duplicateProduct({
        product_type: 'panels',
        product_id: id,
    })
        .then((response) => {
            dispatch(actions[DUPLICATE_SUCCESS](response.data));
            dispatch(fetchItems(filterData));
            showToast({
                body: i18next.t('Successfully duplicated'),
            });
        })
        .catch((error) =>
            dispatch(actions[DUPLICATE_FAILURE](error?.response?.data?.errors)),
        );
};
